<template>
<!-- 转签 -->
  <div class="detail">
    <ax-panel :noTitle="true">
      <van-cell title="员工ID" :value="data.header.emplid"></van-cell>
      <van-cell title="姓名" :value="data.header.emplid_description"></van-cell>
    </ax-panel>
    <ax-panel title="转签信息">
      <van-cell title="新公司实体" :value="data.qh_hr_020_hd01.company_description"></van-cell>
      <van-cell title="新工作地点" :value="data.qh_hr_020_hd01.location_description"></van-cell>
      <van-cell title="新保险缴纳区域" :value="data.qh_hr_020_hd01.gpcn_contrib_area_description"></van-cell>
      <van-cell title="原合同结束日期" :value="data.header.contract_end_dt"></van-cell>
      <van-cell title="新合同开始日期" :value="data.qh_hr_020_hd01.contract_begin_dt"></van-cell>
      <van-cell title="新合同预计结束日期" :value="data.qh_hr_020_hd01.contrct_exp_end_dt"></van-cell>
      <van-cell title="新合同试用期截止日期" :value="data.qh_hr_020_hd01.qh_probation_dt"></van-cell>
      <van-cell title="转签节点日期" :value="data.qh_hr_020_hd01.qh_date_num"></van-cell>
      <!-- <van-cell>
        <p class="title">调整说明</p>
        <textarea
          class="comments_box"
          rows="5"
          v-model="data.header.comments"
          placeholder="请填写转签说明（必填）"
        ></textarea>
      </van-cell> -->
    </ax-panel>
    <!-- 转签需求 -->
    <ax-panel :noTitle="true">
      <van-cell style="border-bottom:none">
        <p class="title">转签需求</p>
      </van-cell>
      <p
        class="desc"
        style="margin-bottom:20px"
      >{{data.header.comments}}</p>
    </ax-panel>
  </div>
</template>

<script>
export default {
  props: ['data']
}
</script>
<style lang="scss" scoped>
.title {
  color: rgba(0, 0, 0, 0.3);
  // color: #000;
  font-size: 0.4rem;
  text-align: left;
  padding-left: 0.42667rem;
}

.desc {
  color: #ccc;
  padding-left: 25px;
  font-size: 0.35rem;
  text-align: left;
  white-space: pre-wrap;
}
// 审批意见框
.comments_box {
  box-sizing: border-box;
  width: 100%;
  outline: none;
  font-size: 14px;
  border: none;
  padding: 8px 16px;
  &::-webkit-input-placeholder {
    color: #c7c7c7;
  }
}
.van-cell .van-cell__value {
  text-align: right;
  padding-right: 0.4rem;
}
.van-cell {
  border-bottom: 1px solid $border-color;
}
.base {
  border-bottom: none;
}
.van-cell__right-icon {
  // margin-left: -2.8rem;
  // float: right;
  position: absolute;
  right: 0.1rem;
}
.van-cell .van-cell__title {
  width: 4rem;
  // color:#000
}
.w100 .van-cell__title {
  width: 8rem;
}
.van-collapse-item__wrapper .van-collapse-item__content {
  color: rgba(0, 0, 0, 0.9);
}
.title {
  color: rgba(0, 0, 0, 0.3);
  // color: #000;
  font-size: 0.4rem;
  text-align: left;
  padding-left: 0.42667rem;
}
.desc {
  color: #ccc;
  padding-left: 25px;
  font-size: 0.35rem;
  text-align: left;
}
</style>
